import { commentItems } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
            <i className="ri-chat-heart-line"></i>
            <span>用户口碑</span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            用户口碑
          </h2>
          <p className="mt-2 text-sm text-foreground-500 max-w-lg mx-auto">
            来自糖心视频真实用户的甜蜜评价与观影感受
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {commentItems.map((item) => (
            <div
              key={item.id}
              className="p-5 md:p-6 rounded-2xl bg-background-100 hover:bg-background-200 transition-colors"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 rounded-full bg-primary-100 flex items-center justify-center text-xl flex-shrink-0">
                  {item.avatar}
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-semibold text-foreground-900 truncate">
                    {item.name}
                  </div>
                  <div className="flex items-center gap-0.5 mt-0.5">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`text-xs ${i < item.rating ? 'text-accent-500 ri-star-fill' : 'text-foreground-300 ri-star-line'}`}
                      ></i>
                    ))}
                  </div>
                </div>
                <span className="text-xs text-foreground-400 ml-auto whitespace-nowrap">
                  {item.date}
                </span>
              </div>

              <p className="text-sm text-foreground-600 leading-relaxed line-clamp-4 mb-3">
                &ldquo;{item.content}&rdquo;
              </p>

              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{item.likes.toLocaleString()}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}